import React from 'react';

interface HeaderSkeletonProps {
  buttonCount?: number;
}

export function HeaderSkeleton({ buttonCount = 2 }: HeaderSkeletonProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 will-change-opacity">
      {/* Title and Subtitle */}
      <div className="space-y-2">
        <div className="h-8 w-40 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="h-5 w-64 bg-gray-200 rounded-md animate-pulse"></div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-3 ml-auto">
        {[...Array(buttonCount)].map((_, index) => (
          <div
            key={index}
            className="h-10 w-28 bg-gray-200 rounded-md animate-pulse"
            style={{ animationDelay: `${index * 0.1}s` }}
          ></div>
        ))}
      </div>
    </div>
  );
}
